import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function YuksekteCalismaEgitimiPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'Yüksekte Çalışma Eğitimi | Adana OSGB Mersin Hatay Osmaniye | ASSA Akademi';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana yüksekte çalışma eğitimi, Mersin yüksekte çalışma eğitimi, Hatay yüksekte çalışma eğitimi, Osmaniye yüksekte çalışma eğitimi. ASSA Akademi IRATA/SPRAT LEVEL 3 eğitmenlerle.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana yüksekte çalışma eğitimi, Mersin yüksekte çalışma eğitimi, Hatay yüksekte çalışma eğitimi, Osmaniye yüksekte çalışma eğitimi, IRATA, SPRAT');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/egitimler/yuksekte-calisma-egitimi');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "Yüksekte Çalışma Eğitimi",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde ASSA Akademi IRATA/SPRAT LEVEL 3 eğitmenlerle yüksekte çalışma eğitimi.",
      "provider": {
        "@type": "Organization",
        "name": "ASSA Akademi",
        "telephone": "+90-850-346-2772"
      },
      "areaServed": ["Adana", "Mersin", "Hatay", "Osmaniye"],
      "url": "https://www.assaosgb.com.tr/egitimler/yuksekte-calisma-egitimi"
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Yüksekte Çalışma Eğitimi</h1>
            <p className="text-xl md:text-2xl mb-8 text-blue-100">
              ASSA Akademi ile Güvenli Yüksekte Çalışma Eğitimi
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-lg">
              <span className="bg-white/20 px-4 py-2 rounded-full">Adana Yüksekte Çalışma</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Mersin Yüksekte Çalışma</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Hatay Yüksekte Çalışma</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Osmaniye Yüksekte Çalışma</span>
            </div>
          </div>
        </div>
      </section>

      {/* ASSA Akademi Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">ASSA Akademi</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Adana, Mersin, Hatay ve Osmaniye illerinde yüksekte çalışma eğitimi konusunda 
              uzmanlaşmış ASSA Akademi, IRATA/SPRAT LEVEL 3 eğitmenlerimizle güvenli çalışma teknikleri öğretir.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/dc58ea3e153ffedae1793516f62faa57.jpg"
                alt="ASSA Akademi Yüksekte Çalışma Eğitimi"
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                  <i className="ri-medal-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">IRATA/SPRAT LEVEL 3 Eğitmenler</h3>
                  <p className="text-gray-600">Uluslararası sertifikalı LEVEL 3 eğitmenlerimizle profesyonel eğitim</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Güvenlik Standartları</h3>
                  <p className="text-gray-600">Uluslararası güvenlik standartlarına uygun eğitim programları</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center">
                  <i className="ri-tools-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Profesyonel Ekipman</h3>
                  <p className="text-gray-600">Son teknoloji güvenlik ekipmanları ile uygulamalı eğitim</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eğitim İçeriği */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Yüksekte Çalışma Eğitimi İçeriği</h2>
            <p className="text-lg text-gray-600">IRATA/SPRAT LEVEL 3 eğitmenlerimizle kapsamlı eğitim programı</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-user-line text-blue-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Güvenlik Ekipmanları</h3>
              <p className="text-gray-600">Emniyet kemeri, halat, karabina ve diğer güvenlik ekipmanlarının doğru kullanımı</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-building-line text-blue-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Rope Access Teknikleri</h3>
              <p className="text-gray-600">IRATA/SPRAT standartlarına uygun halat erişim teknikleri ve uygulamaları</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-first-aid-kit-line text-blue-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Acil Durum Prosedürleri</h3>
              <p className="text-gray-600">Yüksekte çalışma sırasında karşılaşılabilecek acil durumlar ve müdahale yöntemleri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-search-line text-blue-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Risk Değerlendirmesi</h3>
              <p className="text-gray-600">Yüksekte çalışma öncesi risk analizi ve güvenlik önlemlerinin belirlenmesi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-book-line text-blue-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Mevzuat Bilgisi</h3>
              <p className="text-gray-600">Yüksekte çalışma ile ilgili yasal düzenlemeler ve standartlar</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-tools-line text-blue-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Uygulamalı Eğitim</h3>
              <p className="text-gray-600">LEVEL 3 eğitmenler eşliğinde gerçek koşullarda pratik uygulamalar</p>
            </div>
          </div>
        </div>
      </section>

      {/* Şehirler */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Hizmet Verdiğimiz İller</h2>
            <p className="text-lg text-gray-600">ASSA Akademi Yüksekte Çalışma Eğitimleri</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Adana</h3>
              <p className="text-gray-600">Adana Yüksekte Çalışma Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Mersin</h3>
              <p className="text-gray-600">Mersin Yüksekte Çalışma Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hatay</h3>
              <p className="text-gray-600">Hatay Yüksekte Çalışma Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Osmaniye</h3>
              <p className="text-gray-600">Osmaniye Yüksekte Çalışma Eğitimi</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Yüksekte Çalışma Eğitimi Almak İster misiniz?</h2>
          <p className="text-xl text-blue-100 mb-8">
            ASSA Akademi ile güvenli yüksekte çalışma teknikleri öğrenin
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Bilgi Al
            </Link>
            <a 
              href="tel:08503462772" 
              className="bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-800 transition-colors whitespace-nowrap"
            >
              Hemen Ara
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
